import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/NotFound.css';

const NotFound = () => {
  const { t, language } = useLanguage();
  
  return (
    <div className="not-found-container">
      <div className="header-spacer"></div>
      <div className="not-found-content">
        <div className="not-found-icon">404</div>
        <h1 className="not-found-title">{t("pageNotFound")}</h1>
        <p className="not-found-message">{t("pageNotFoundMessage")}</p>
        <Link to="/" className="back-home-button">
          {t("backToHome")}
        </Link>
      </div>
      
      <div className="not-found-decoration">
        <div className="decoration-element"></div>
        <div className="decoration-element"></div>
        <div className="decoration-element"></div>
      </div>
    </div>
  );
};

export default NotFound;
